/**
 * Mapa v kontaktu (blok „mapa" z content builderu) – Leaflet + dlaždice OSM.
 *
 * Proč Leaflet a ne vložený rámec z openstreetmap.org: bezpečnostní hlavička
 * cms.local (Content-Security-Policy v boot.php) pouští cizí zdroje jen pro
 * dlaždice OSM, iframe by prohlížeč zablokoval (stejně jako v kominik.local).
 *
 * Knihovna (~40 kB gzip) se stahuje, až když je mapa kousek pod obrazovkou –
 * ostatní stránky ani úvod kontaktu ji neplatí. Značka je vlastní (divIcon
 * v barvách webu), takže se nestahují ani obrázky markeru.
 *
 * Přístupnost: mapa je jen doplněk, adresa je vždy i textem pod ní a odkaz
 * vede na navigaci (WCAG 1.1.1). Kolečko myši mapu nezoomuje, dokud do ní
 * návštěvník neklikne – jinak by se přes ni nedalo rolovat stránkou.
 */
import { loadVendor } from './lazy-vendor.js';

const LEAFLET_JS  = '/www/assets/js/vendor/leaflet/leaflet.min.js';
const LEAFLET_CSS = '/www/assets/js/vendor/leaflet/leaflet.min.css';

function loadCss() {
    if (document.querySelector('link[data-leaflet]')) return;
    const link = document.createElement('link');
    link.rel = 'stylesheet';
    link.href = LEAFLET_CSS;
    link.dataset.leaflet = '';
    document.head.appendChild(link);
}

async function initMap(el) {
    const lat = parseFloat(el.dataset.lat);
    const lon = parseFloat(el.dataset.lon);
    if (!Number.isFinite(lat) || !Number.isFinite(lon)) return;

    loadCss();
    if (!await loadVendor(LEAFLET_JS) || typeof L === 'undefined') return; // zůstane adresa + odkaz

    const map = L.map(el, { scrollWheelZoom: false }).setView([lat, lon], 15);

    L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
        maxZoom: 19,
        attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a>',
    }).addTo(map);

    const icon = L.divIcon({ className: 'map-pin', html: '<span></span>', iconSize: [36, 46], iconAnchor: [18, 46] });
    L.marker([lat, lon], { icon, title: el.dataset.label || '', keyboard: false }).addTo(map);

    map.on('click', () => map.scrollWheelZoom.enable());
    map.on('mouseout', () => map.scrollWheelZoom.disable());
}

function init() {
    const maps = document.querySelectorAll('[data-map]');
    if (!maps.length) return;

    const io = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
            if (!entry.isIntersecting) return;
            io.unobserve(entry.target);
            initMap(entry.target);
        });
    }, { rootMargin: '300px 0px' });

    maps.forEach((el) => io.observe(el));
}

document.addEventListener('DOMContentLoaded', init);
